import { ruleLanguageSpec } from "./languageSpec.js";

export const REGEX = {
    ws: /[ \t\r\n]+/y,
    number: /-?(?:\d+\.?\d*|\d*\.?\d+)/y,
    alpha: /[A-Za-z_][A-Za-z0-9_]*/y,
    percent: /%/y,
    dollar: /\$/y,
    listBracket: /\[/y,
    backtick: /`/y,
    lparen: /\(/y,
    rparen: /\)/y,
    lbrace: /{/y,
    rbrace: /}/y,
    comma: /,/y,
};

export const KEYWORDS = new Set(ruleLanguageSpec.keywords);
export const PRIMITIVES = new Set(ruleLanguageSpec.primitives);

function escapeRegex(s) {
    return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}

export const OPS_SORTED = [...ruleLanguageSpec.operators]
    .sort((a, b) => b.lexeme.length - a.lexeme.length)
    .map(o => ({ id: o.id, lexeme: new RegExp(escapeRegex(o.lexeme), "y"), meta: o }));

export function isPrimitiveTypeLexeme(x) {
    return PRIMITIVES.has(x);
}
